import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["DropdownMenuPortal"], null, {
        default: _withCtx(() => [
            _createVNode($setup["DropdownMenuSubContent"], _mergeProps({ ...$setup.forwarded, ..._ctx.$attrs }, {
                class: $setup.cn('z-50 min-w-32 rounded-md border border-border bg-popover p-2.5 text-popover-foreground shadow-md outline-none', 'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95', 'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95', $setup.props.class)
            }), {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3 /* FORWARDED */
            }, 16 /* FULL_PROPS */, ["class"])
        ]),
        _: 3 /* FORWARDED */
    }));
}
